import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable ,  forkJoin } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export class CustomTranslateLoader implements TranslateLoader {
    private http: HttpClient;
    constructor(http: HttpClient) {
        this.http = http;
    }

    // Para usar el refactor
    // getTranslation(lang: string): Observable<any> {
    //     const langs = forkJoin(
    //         this.http.get(`${environment.ruta_traducciones}${lang}.json`),
    //         this.http.get(`${environment.ruta_traducciones}${lang}_refactor.json`),
    //     );
    //     return langs.pipe(
    //         map((res: any) => {
    //             const resp = { ...res[0], ...res[1] };
    //             return resp;
    //         }));
    // }
    getTranslation(lang: string): Observable<any> {
        return this.http.get(`${environment.ruta_traducciones}${lang}.json`);

    }
}
